import React from 'react';
import * as Formatting from 'fw/misc/Formatting'

class ClientDate extends React.Component {
	shouldComponentUpdate(nextProps) {
		return (
			nextProps.value !== this.props.value);
	}

	render() {
        return <React.Fragment>{Formatting.formatClientDate(this.props.value)}</React.Fragment>
    }
}

export default ClientDate;


// WEBPACK FOOTER //
// ./src/fw/components/formatter/ClientDate.js